export class DoorWidthAndPhysicalSeparationFactorData
{
    colId:number;
    doorWidthCalculatedId:number;
    value:number;
}